exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#print-bill{border:1px solid #f2f2f2;width:98%}@media print{body{-webkit-print-color-adjust:exact}.hideWhenPrint{display:none}#print-bill,.card,.card-body,.contianer{border:0}}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/views/expen_detail.vue"],"names":[],"mappings":"AACA,YACE,yBAA0B,AAC1B,SAAW,CACZ,AACD,aACA,KACI,gCAAkC,CACrC,AACD,eACI,YAAc,CACjB,AAMD,wCACI,QAAY,CACf,CACA","file":"expen_detail.vue","sourcesContent":["\n#print-bill {\r\n  border: 1px #f2f2f2 solid;\r\n  width: 98%;\n}\n@media print {\nbody {\r\n    -webkit-print-color-adjust: exact;\n}\n.hideWhenPrint {\r\n    display: none;\n}\n.card,\r\n  .card-body,\r\n  .contianer {\r\n    border: 0px;\n}\n#print-bill {\r\n    border: 0px;\n}\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cb9be528","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/expen_detail.vue
// module id = 381
// module chunks = 26